import { useEffect } from "react";

import { Typography } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
import { toast } from "react-toastify";

import { apis, callApi } from "../../../../../api";
import { defaultTimezone, timezones } from "../../../../../constants/timezone";
import { AccountService, useAccount } from "../../../../../hooks/useAccount";
import { CommonAutocomplete } from "../../../../common/Input/CommonAutocomplete";

export function Timezone() {
	const { account } = useAccount();

	const defaultValues = {
		timezoneName: account?.timezoneName ?? defaultTimezone,
	};

	const { control, setValue } = useForm({
		defaultValues,
		mode: "all",
	});
	const { timezoneName } = useWatch({ control });

	useEffect(() => {
		const saveTimezone = async (timezoneName: string) => {
			const body = {
				...(AccountService.savedAccount ?? {}),
				timezoneName,
			};

			try {
				const response = await callApi({
					method: "PATCH",
					url: apis.UPDATE_USER_INFORMATION,
					body,
				});

				if (!response.user) {
					return;
				}

				toast.success("Saved changes!");
				AccountService.saveAccount(response.user);
			} catch (error) {}
		};

		if (timezoneName && timezoneName !== account?.timezoneName) {
			saveTimezone(timezoneName);
		}
	}, [account?.timezoneName, timezoneName]);

	useEffect(() => {
		setValue("timezoneName", account?.timezoneName ?? defaultTimezone);
	}, [account?.timezoneName, setValue]);

	return (
		<>
			<Typography className="small-title-text bold">Time Zone</Typography>
			<div className="item-separator-small" />
			<CommonAutocomplete
				control={control}
				name="timezoneName"
				placeholder="Your timezone*"
				options={timezones}
				rules={{
					required: {
						value: true,
						message: "Timezone is required.",
					},
				}}
			/>
		</>
	);
}
